import { render, staticRenderFns } from "./RegisterDes.vue?vue&type=template&id=0f8bd37d&scoped=true"
import script from "./RegisterDes.vue?vue&type=script&lang=js"
export * from "./RegisterDes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8bd37d",
  null
  
)

export default component.exports